import MuiTextField from '@mui/material/TextField'
import styled from '@emotion/styled'
import { MenuItem } from '@mui/material'
import { theme } from '../../themes/theme'
import { formSection } from './FormStyleConfig'

const inputField = theme.colors.inputField

const ControlledInput = styled.input`
  box-sizing: border-box;
  font: inherit;
  font-size: 14px;
  color: ${inputField.text};
  background: ${inputField.background};
  border: 1px solid ${inputField.border};
  border-radius: ${theme.borderRadius.input};

  :focus {
    outline: none;
    border-color: ${inputField.focusedBorder};
  }
`

const TextField = styled(MuiTextField)`
  .MuiInputBase-root.MuiInput-root:hover:not(.Mui-disabled, .Mui-error):before {
    border-bottom: none !important;
  }

  .MuiInputBase-root.MuiInput-root::before,
  .MuiInputBase-root.MuiInput-root::after {
    border-bottom: none !important;
  }

  .MuiInput-root {
    padding: 0;
    margin-top: ${({ haslabel, styleformat }) =>
      haslabel && haslabel === 'false'
        ? '0'
        : styleformat
          ? formSection[styleformat].muiTextField.topMargin
          : formSection['default'].muiTextField.topMargin};
  }

  .MuiInputLabel-asterisk {
    color: ${theme.colors.error} !important;
  }

  .MuiFormHelperText-root {
    padding-top: 5px;
    font-size: 12px;
    color: ${theme.colors.error} !important;
    font-family: ${theme.fonts.body};
    letter-spacing: 0;
  }

  .MuiInputLabel-root {
    font-family: ${theme.fonts.body};
    letter-spacing: 0;
    font-size: ${props =>
      props.styleformat !== undefined
        ? formSection[props.styleformat].muiTextField.labelFontSize
        : formSection['default'].muiTextField.labelFontSize};
    color: ${inputField.text};
  }

  .MuiInputBase-root.Mui-disabled {
    border: 1px solid ${inputField.background};
  }

  .MuiInputBase-input.MuiInput-input.Mui-disabled {
    color: ${inputField.disabledText};
    -webkit-text-fill-color: ${inputField.disabledText};
  }

  .MuiInputBase-root {
    color: ${inputField.text};
    font-size: 14px;
    font-family: ${theme.fonts.body};
    font-weight: 400;
    line-height: 18px;

    background: ${inputField.background};
    border: ${({ error }) => (error ? `1px solid ${theme.colors.error} !important` : `1px solid ${inputField.border}`)};
    border-radius: ${theme.borderRadius.input};

    .MuiInputBase-input {
      padding: 8px 15px;
    }

    .MuiIconButton-root {
      padding: 8px;
    }
  }

  .MuiInputAdornment-root {
    margin: 0;

    .MuiSvgIcon-root {
      padding: 0;
      color: ${inputField.text};
      font-size: 18px;
    }
  }

  .MuiInputAdornment-positionEnd {
    margin-right: 10px;
  }

  .MuiInputAdornment-positionStart {
    margin-left: 10px;
  }

  .Mui-focused {
    border: 1px solid ${inputField.focusedBorder};
  }

  & .Mui-focused .MuiOutlinedInput-notchedOutline {
    border: 1px solid ${inputField.focusedBorder} !important;
  }

  .MuiOutlinedInput-root {
    border: none;
  }

  .MuiFormHelperText-root.Mui-focused {
    border: none;
  }

  .MuiSelect-icon {
    padding-right: 8px;
  }

  .MuiSelect-iconOpen {
    padding-left: 8px;
  }

  .MuiSelect-select.MuiInputBase-input.MuiInput-input {
    padding-right: 35px;
  }

  .MuiButtonBase-root.MuiMenuItem-root {
    font-family: ${theme.fonts.body} !important;
  }

  &.MuiChip-root {
    border-radius: ${theme.borderRadius.iconButton};
    background-color: ${theme.colors.background.medium};
    height: auto;
    padding: 5px 0;
  }

  .MuiChip-label {
    color: ${theme.colors.text.body};
    font-family: ${theme.fonts.body};
    font-weight: 500;
    white-space: wrap;
    padding: 0 10px;
  }
`

const SelectMenuItem = styled(MenuItem)`
  font-family: ${theme.fonts.body} !important;
  font-size: 14px !important;

  &&:hover {
    background-color: ${theme.colors.primaryExtraLight};
  }

  &.Mui-selected {
    background-color: ${theme.colors.primaryLight} !important;
    font-family: ${theme.fonts.body};

    :hover {
      background-color: ${theme.colors.primaryExtraLight} !important;
    }
  }

  &[role='option'][aria-selected='true'] {
    background-color: ${theme.colors.primaryLight} !important;
  }

  &.Mui-focused {
    background-color: ${theme.colors.primaryExtraLight} !important;
  }
`

export { TextField, ControlledInput, SelectMenuItem }
